import { takeLatest } from 'redux-saga/effects';
import { updateAppMissionSaga } from './update-app-mission-saga';
import { UPDATE_APP_MISSION_START } from 'redux/actions/types';

export default function* updateAppEventSagas() {
  yield takeLatest(UPDATE_APP_MISSION_START, updateAppMissionSaga);
}
